import reduxStore from 'redux/store'
import {clearResource, setResource, setSaveStatusDialog, setSaveStatusError, setSaveStatusLoading} from 'redux/actions'
import Endpoints from 'constants/Endpoints';
import {RestRequestDELETE, RestRequestGET, RestRequestPOST} from 'libs/RestRequest';
import validateSection from './helpers/validateSection'
import {DemandValidation} from 'constants/DemandValidation';
import objectExtension from 'libs/objectExtension';

const SCHEDULE_RESOURCE_ID = 'schedule';

const getList = async (id) => {
    try {
        const res = await RestRequestGET(Endpoints.SCHEDULE(id))

        reduxStore.dispatch(
            setResource(SCHEDULE_RESOURCE_ID, res)
        )
    } catch (error) {
    }
}


const _save = async (url, values) => {
    const data = _prepareData(values);

    const {resources} = reduxStore.getState()
    const {schedule} = resources;
    const diff = objectExtension.diff(data, schedule);
    if (diff === null) return null;

    try {
        return await RestRequestPOST(url, data)
    } catch (error) {
        throw error;
    }
}

const _prepareData = (values) => {
    const {
        offerEndDate,
        offerOpenDate,
        bindWithOfferPeriodOrDate,
        ...other
    } = values;

    let isDate = bindWithOfferPeriodOrDate.pickDateInsteadOfPeriod;

    let offer;
    if (isDate === "empty") offer = null
    else if (isDate === "true") offer = {date: bindWithOfferPeriodOrDate.date.format()}
    else offer = {period: bindWithOfferPeriodOrDate.period}

    const data = {
        schedules: [{
            offerEndDate: offerEndDate ? offerEndDate.format() : null,
            offerOpenDate: offerOpenDate ? offerOpenDate.format() : null,
            bindWithOfferPeriodOrDate: offer,
            ...other
        }]
    }
    return data;
}

const save = async (id, values) => {
    reduxStore.dispatch(setSaveStatusLoading());
    try {
        const res = await _save(Endpoints.SCHEDULE_SAVE(id), values)
        if (res === null || res.success) {
            await getList(id);
            reduxStore.dispatch(setSaveStatusDialog());
            await validateSection(DemandValidation.SCHEDULE, id);
            await validateSection(DemandValidation.APPROVAL, id);
            const {resources} = reduxStore.getState();
            const {demandHeader} = resources;
            if (demandHeader && demandHeader.noticeOjsType)
                await validateSection(DemandValidation.NOTICE, id);
            if (demandHeader && demandHeader.noticeBzpType)
                await validateSection(DemandValidation.NATIONAL_NOTICE, id);

            await validateSection(DemandValidation.PUBLICATION, id);
        } else {
            reduxStore.dispatch(setSaveStatusError());
            await validateSection(DemandValidation.SCHEDULE, id, false);
        }
        return res;
    } catch (error) {
        console.error(error)
    }
}

const clearSchedule = async () => {
    reduxStore.dispatch(clearResource(SCHEDULE_RESOURCE_ID))
}

const validate = async (id) => {
    return RestRequestGET(Endpoints.SCHEDULE_VALIDATE(id));
}

const checkForDraft = async (id) => {
    return await RestRequestGET(Endpoints.SCHEDULE_AUTOSAVE_CHECK(id));
}

const loadDraft = async (id) => {
    const res = await RestRequestGET(Endpoints.SCHEDULE_AUTOSAVE(id));
    reduxStore.dispatch(setResource(SCHEDULE_RESOURCE_ID, res.result));
    return res;
}

const saveDraft = async (id, formValues) => {
    const data = _prepareData(formValues);
    await RestRequestPOST(Endpoints.SCHEDULE_AUTOSAVE(id), data);
}

const deleteDraft = async (id) => {
    await RestRequestDELETE(Endpoints.SCHEDULE_AUTOSAVE(id));
}

export default {
    save,
    getList,
    validate,
    clearSchedule,
    checkForDraft,
    loadDraft,
    saveDraft,
    deleteDraft,
    SCHEDULE_RESOURCE_ID
    //auto Save,
    //auto SaveCheck,
    //auto SaveDelete,
    //auto SaveLoad,
    //restoreAuto save,
}